import consumerApi from "api/services/consumer-api";
import { ShopResponse, ShopTypes } from "custom-types/Shop";
import { Coordinates } from "custom-types/Coordinates";
import { Query } from "custom-types/Query";
import { stringify } from "qs";

const getSearchShopResults = async (
  query: Query,
  coordinates: Coordinates,
  maxDistance: number,
  countryCode?: string
) => {
  const route = "/api/search/v1/shop";

  const body = stringify(
    {
      ...query,
      ...coordinates,
      "filter[max_distance]": maxDistance || 30,
      take: 20,
    },
    {
      arrayFormat: "brackets",
      encodeValuesOnly: true,
    }
  );
  try {
    const { data } = await consumerApi.get<ShopResponse>(`${route}?${body}`, {
      headers: {
        "x-country-code": countryCode || "US",
      },
    });

    const {
      hits: { strain, brand, dispensary },
      metadata: { availableFilters, relevanceOrder, totalCount },
    } = data;

    const mappedFilters = availableFilters.map((filter) => ({
      ...filter,
      values: filter.values.map((value) => value.value),
    }));

    const relevantTab = Object.entries(relevanceOrder)
      .filter(([key]) =>
        ["brand", "dispensary", "strain", "menuItem"].includes(key)
      )
      .sort(([, aValue], [, bValue]) => bValue - aValue);
    const initialTab = relevantTab[0][0] as ShopTypes;

    return {
      brand: brand || [],
      dispensary: dispensary || [],
      strain: strain || [],
      availableFilters: mappedFilters,
      totalCount,
      initialTab,
    };
  } catch (err) {
    return {
      brand: [],
      dispensary: [],
      strain: [],
      availableFilters: [],
    };
  }
};

export default getSearchShopResults;
